import React from "react";
import { StoryNode } from "../../StoryBook/StoryData";
import { Box } from "@mui/material";
import { PropertyEditorCollapse } from "../PropertyEditorCollapse";
import { PropertyEditorBoolean } from "../PropertyEditorBoolean";

const editObj: { boolVal?: boolean; boolVal2?: boolean } = {};

export const CollapsePropertyEditorStories = [
    new StoryNode(
        () => {
            return (
                <Box
                    display={"flex"}
                    flexDirection={"column"}
                >
                    <PropertyEditorBoolean
                        editObject={editObj}
                        propertyName={"boolVal"}
                    ></PropertyEditorBoolean>
                    <PropertyEditorCollapse
                        editObject={editObj}
                        collapseLogicOrField={"boolVal"}
                    >
                        show me
                    </PropertyEditorCollapse>
                </Box>
            );
        },
        "Shared",
        "Property Editors",
        "Collapse",
        "Field"
    ),
    new StoryNode(
        () => {
            return (
                <Box
                    display={"flex"}
                    flexDirection={"column"}
                >
                    Show if both are true
                    <PropertyEditorBoolean
                        editObject={editObj}
                        propertyName={"boolVal"}
                    ></PropertyEditorBoolean>
                    <PropertyEditorBoolean
                        editObject={editObj}
                        propertyName={"boolVal2"}
                    ></PropertyEditorBoolean>
                    <PropertyEditorCollapse
                        editObject={editObj}
                        collapseLogicOrField={() => {
                            return (editObj.boolVal && editObj.boolVal2) || false;
                        }}
                        observeProperties={["boolVal", "boolVal2"]}
                    >
                        show me
                    </PropertyEditorCollapse>
                </Box>
            );
        },
        "Shared",
        "Property Editors",
        "Collapse",
        "Function"
    ),
];
